var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentGrades(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1667 0C66.6197 0 67.8173 1.09378 67.9809 2.50291L68 2.83333L68 65.1667C68 66.6197 66.9062 67.8173 65.4971 67.9809L65.1667 68L2.83333 68C1.26853 68 0 66.7315 0 65.1667C0 63.7136 1.09378 62.5161 2.50291 62.3524L2.83333 62.3333L62.3333 62.3333L62.3333 5.66667L5.66667 5.66667L5.66667 42.5C5.66667 43.953 4.57289 45.1506 3.16376 45.3143L2.83333 45.3333C1.3803 45.3333 0.18273 44.2396 0.0190619 42.8304L0 42.5L0 2.83333C0 1.3803 1.09378 0.18273 2.50291 0.0190619L2.83333 0L65.1667 0Z",
    transform: "matrix(1 0 0 -1 11 79)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(11 22)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2201 0.82996C10.9073 -0.865925 13.7401 0.209214 13.9832 2.50024L14 2.82004L14 35.1856C14 36.74 12.7464 38 11.2 38C9.76406 38 8.58058 36.9135 8.41884 35.5138L8.4 35.1856L8.4 9.61399L4.7799 13.2533C3.77054 14.2679 2.1823 14.3459 1.08388 13.4874L0.820101 13.2533C-0.189254 12.2388 -0.266897 10.6424 0.587173 9.53829L0.820101 9.27315L9.2201 0.82996Z",
    transform: "translate(23 28)",
    id: "Path-16",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.39991 0 0.370855 4.61427 0.0194553 10.4907L0.00119911 11.0624L0 27.8571L0.0158406 28.4286C0.370855 34.3857 5.39991 39 11.5 39C17.8513 39 23 34.0112 23 27.8571L23 11.1429L22.9842 10.5714C22.6291 4.61427 17.6001 0 11.5 0ZM11.5 5.57143C14.5494 5.57143 17.0647 7.87933 17.2402 10.813L17.2512 11.2233L17.25 27.8571C17.25 30.9342 14.6756 33.4286 11.5 33.4286C8.45061 33.4286 5.93525 31.1207 5.75983 28.1871L5.7488 27.7767L5.75 11.1429L5.76344 10.7323C5.93525 7.87933 8.45061 5.57143 11.5 5.57143Z",
    transform: "translate(45 28)",
    id: "Path",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentGrades);
export default __webpack_public_path__ + "static/media/studentGrades.d234136f90cd9ca701906d8acb6fb8f1.svg";
export { ForwardRef as ReactComponent };